<div class="col-12 m-0">
  <form [formGroup]="form" class="contact-form">
    <span class="f-int">Dati istituto scolastico</span>
    <div class="row mt-3 mb-3">
      <div class="col-12">
        <label>Nome della scuola*</label>
        <input
          class="f-input"
          type="text"
          formControlName="school_name"
          placeholder="Inserisci nome scuola"
        />
        <tui-error
          [formControl]="form.controls.school_name"
          [error]="[] | tuiFieldError | async"
        ></tui-error>
      </div>
    </div>
    <div class="row mt-2 mb-3">
      <div class="col-12">
        <label>Indirizzo della scuola*</label>
        <input
          class="f-input"
          type="text"
          formControlName="school_address"
          placeholder="Inserisci indirizzo scuola"
        />
        <tui-error
          [formControl]="form.controls.school_address"
          [error]="[] | tuiFieldError | async"
        ></tui-error>
      </div>
    </div>
    <span class="f-int mb-3">Dati referente</span>

    <div class="row mt-3 mb-3">
      <div class="col-6">
        <label>Nome*</label><br />
        <input
          class="f-input"
          type="text"
          formControlName="name"
          placeholder="Inserisci il nome"
        />
        <tui-error
          [formControl]="form.controls.name"
          [error]="[] | tuiFieldError | async"
        ></tui-error>
      </div>
      <div class="col-6">
        <label>Cognome*</label>
        <input
          class="f-input"
          type="text"
          formControlName="surname"
          placeholder="Inserisci il cognome"
        />
        <tui-error
          [formControl]="form.controls.surname"
          [error]="[] | tuiFieldError | async"
        ></tui-error>
      </div>
    </div>
    <div class="row mt-2 mb-3">
      <div class="col-12">
        <label>Email*</label>
        <input
          class="f-input"
          type="email"
          formControlName="email"
          placeholder="Inserisci email"
        />
        <tui-error
          [formControl]="form.controls.email"
          [error]="[] | tuiFieldError | async"
        ></tui-error>
      </div>
      <div class="col-12 mt-2">
        <label>Telefono*</label>
        <input
          class="f-input"
          type="text"
          formControlName="telefono"
          placeholder="Inserisci telefono"
        />
        <tui-error
          [formControl]="form.controls.telefono"
          [error]="[] | tuiFieldError | async"
        ></tui-error>
      </div>
    </div>
    <div class="row mt-2 mb-3"></div>

    <div class="row mt-2 mb-3">
      <span class="privacy">
        Ai sensi e per gli effetti degli artt. 6, 7, 12, 13 del Reg. UE 2016/679
        – GDPR, cliccando su "Invia la tua candidatura", dichiaro di aver preso
        visione dell’informativa per il
        <a
          href="assets/docs/easycode_Luna_Labs_Privacy_Policy_Website.pdf"
          class="text-reset"
          >trattamento dei dati personali</a
        >. <br /><br />
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </span>
    </div>
    <tui-error
      [formControl]="form.controls.privacy"
      [error]="[] | tuiFieldError | async"
    ></tui-error>

    <div class="row">
      <button class="btn-lightblue" [disabled]="form.invalid">
        <span class="button-txt" (click)="sendEmail()"
          >Invia la tua candidatura</span
        >
      </button>
    </div>
  </form>
</div>
